// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-wrapper[data-v-4259204b]{transition:transform .4s cubic-bezier(0,0,.3,1);position:relative;overflow:hidden;display:flex;flex-direction:column;background-color:var(--wb-white);max-height:calc(100vh - 80px);border-radius:0 0 4px 4px}@media(min-width:48em){.content-wrapper[data-v-4259204b]{max-height:521px}}.divider[data-v-4259204b]{margin:0;border:0;border-bottom:1px solid var(--wb-grey-70)}", ""]);
// Exports
module.exports = exports;
